module.exports = __webpack_public_path__ + "static/wechat-2a23cc51c14b27c17d2b372f871d68ec.jpg";